<template>
  <sys-data-table
    :headers="headers"
    :items="items"
    :items-per-page="-1"
    height="300"
    :item-height="25"
    :fixed-header="true"
    :item-class="itemClass"
    item-key="index"
    dense
    style="height: 100%;"
  >
    <template #top>
      <div class="d-flex align-center py-2">
        <v-icon class="mr-1" :size="22">mdi-format-list-bulleted</v-icon>
        <p class="pa-0 ma-0 font-17 font-weight-medium text-no-wrap">Estoque por Lotes</p>
      </div>
    </template>

    <template #item.qtde="{ item }">
      {{ Helpers.formatarValorComCasas(item.qtde, 2) }}
    </template>

    <template #item.pp="{ item }">
      {{ item.numlote === '-' ? '-' : Helpers.formatarValorComCasas(props.ponto_pedido, 2) }}
    </template>

    <template #item.emax="{ item }">
      {{ item.numlote === '-' ? '-' : Helpers.formatarValorComCasas(props.cobertura_estoque, 2) }}
    </template>

    <template #footer.prepend>
      <div class="d-flex align-center">
        <div class="bg-red-50 quadrado-15 mx-1 cursor-help" title="Ponta de Estoque">&nbsp;</div>
        <span class="pt-1 font-12">
          Ponta de Estoque (< {{ Helpers.formatarValorComCasas(props.ponta_estoque_percentual, 2) }})
        </span>
      </div>
    </template>
  </sys-data-table>
</template>

<script setup>
import Api from "@/api/api.js";
import { logout } from "@/helpers";
import { useResize } from "@/helpers/Resize";
import { onMounted, ref, watch } from "vue";

const { altura_janela } = useResize();

const props = defineProps({
  produto: Object,
  ponta_estoque_percentual: [Number, String],
  valor_fixo: [Number, String],
  cobertura_estoque: [Number, String],
  ponto_pedido: [Number, String]
});

const items = ref([]);

const headers = [
  { text: "Nº Lote", value: "numlote" },
  { text: "Filial", value: "filial" },
  { text: "Qtde", value: "qtde" },
  // { text: "Ponto Pedido", value: "pp" },
  // { text: "Estoque Máximo", value: "emax" },
];

watch(() => props.produto.index, () => buscarEstoquePorLote());
watch(() => props.ponta_estoque_percentual, () => tratarListaDeItens(items.value));

onMounted(buscarEstoquePorLote);

function buscarEstoquePorLote() {
  const params = props.produto;
  Api.get("/compras/produtos/analise-por-lotes/buscar-estoque-por-lote", {params})
    .then(response => tratarListaDeItens(response.data.items))
    .catch(logout);
}


function tratarListaDeItens(lista) {
  if (!Array.isArray(lista)) {
    return lista;
  }
  const lista_filter = lista.filter(ft => ft.numlote !== '-');
  const total_qtde = lista_filter.reduce((acumulador, item) => (parseFloat(item.qtde) <= props.ponta_estoque_percentual) ? acumulador : (acumulador + parseFloat(item.qtde)), 0);

  items.value = [
    { numlote: '-', filial: '-', qtde: total_qtde, pp: 0, emax: 0 },
    ...lista_filter
  ];
}

function itemClass(item) {
  if (item.numlote === '-') {
    return null;
  }
  return {
    'bg-red-50': item.qtde < props.ponta_estoque_percentual,
  }
}
</script>
